import { Box, Text, VStack } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface DashboardCardProps {
  title: string;
  children: ReactNode;
  height?: string | number;
}

export default function DashboardCard({
  title,
  children,
  height = '100%',
}: DashboardCardProps) {
  return (
    <Box
      p={5}
      shadow="lg"
      borderWidth="1px"
      borderRadius="lg"
      background="linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)"
      borderColor="gray.200"
      height={height}
    >
      <VStack gap={4} align="stretch" height="100%">
        <Text fontSize="18px" fontWeight={600} color="#2D3748" mb={0}>
          {title}
        </Text>
        <Box flex="1">{children}</Box>
      </VStack>
    </Box>
  );
}
